"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var react_toastify_1 = require("react-toastify");
var __1 = require("../../");
var PageHeader_1 = __importDefault(require("../PageHeader"));
var Container_1 = __importDefault(require("../Container"));
var NavBar_1 = __importDefault(require("../NavBar/NavBar"));
require("./AppLayout.scss");
var AppLayout = function (_a) {
    var breadcrumbs = _a.breadcrumbs, children = _a.children, dusk = _a.dusk, menu = _a.menu, menuTitle = _a.menuTitle, title = _a.title, user = _a.user, userMenu = _a.userMenu;
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement("div", { className: "app-layout__bg" }),
        react_1.default.createElement("div", { "data-optiiva-app": true, "data-dusk": dusk, className: "app-layout" },
            react_1.default.createElement(NavBar_1.default, { title: menuTitle, user: user, userMenu: userMenu, menu: menu }),
            react_1.default.createElement(Container_1.default, { className: "flex flex-col flex-grow relative z-10" },
                title && (react_1.default.createElement(PageHeader_1.default, { dusk: "page-header", title: title, breadcrumbs: breadcrumbs || [] })),
                react_1.default.createElement("div", null, children)),
            react_1.default.createElement(react_toastify_1.ToastContainer, null),
            react_1.default.createElement(__1.SuccessFlashMessages, null),
            react_1.default.createElement(__1.ErrorFlashMessages, null))));
};
exports.default = AppLayout;
//# sourceMappingURL=AppLayout.js.map